import { margins } from '@olist/styled-system';
import styled, { keyframes, css } from 'styled-components';

const SkeletonAnimation = keyframes `
  from {
    background-position-x: 200%;
  }

  to {
    background-position-x: 0%;
  }
`;
const StyledSkeleton = styled.div(({ theme, width, height, round = false }) => css `
    background: linear-gradient(
      to right,
      ${theme.olist.color.neutral.softer} 0%,
      ${theme.olist.color.neutral.softest} 25%,
      ${theme.olist.color.neutral.softer} 50%
    );
    background-size: 200%;
    cursor: progress;

    @media (prefers-reduced-motion: no-preference) {
      animation: ${SkeletonAnimation} 2s linear infinite;
    }

    ${round
    ? css `
          width: ${height || width};
          height: ${height || width};
          border-radius: ${theme.olist.borderRadius.circle};
        `
    : css `
          width: ${width};
          height: ${height};
          border-radius: ${theme.olist.borderRadius['1xsmall']};
        `}

    ${margins}
  `);

export { StyledSkeleton };
